import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ClientsPageRoutingModule } from './clients-routing.module';

import { ClientsPage } from './clients.page';

import { StylistPickerModule } from '../components/stylist-picker/stylist-picker.module';

import { ClientPickerModule } from '../components/smr-client-picker/smr-client-picker.module';

import { TapRetryComponentModule } from '../components/tap-retry/tap-retry.module';

import { ClientMergeModule } from '../components/client-merge/client-merge.module';

import { ClientFormPageComponentModule } from '../components/client-form-page/client-form-page.module'

import { MenuButtonComponentModule } from 'src/app/components/smr-menu-button/smr-menu-button.module';

import { ClientDetailPageModule } from './client-detail/client-detail.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ClientsPageRoutingModule,
    StylistPickerModule,
    ClientPickerModule,
    ClientMergeModule,
    ClientFormPageComponentModule,
    TapRetryComponentModule,
    MenuButtonComponentModule,
    ClientDetailPageModule
  ],
  declarations: [ClientsPage ],
})
export class ClientsPageModule {}
